import React, { useEffect, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import AppConfig from '../../config';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import { appSlice } from '../../store/slices';
import Icon, { Icons } from '../Icon/Icon';
import './CardActions.scss';

const { routes } = AppConfig;

const CardActions = ({ dailyLimit = 10000, currency = '$', cardInfo = {} }) => {
	const [freeze, setFreeze] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);
	const menuRef = useRef(null);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	// close menu on outside click
	useEffect(() => {
		if (!menuOpen) return;

		const handleClick = e => {
			if (!menuRef.current?.contains(e.target)) {
				setMenuOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClick);
		return () => document.removeEventListener('mousedown', handleClick);
	}, [menuOpen]);

	const handleToggleCard = () => {
		// setFreeze(prev => !prev);
		const mode = freeze;
		dispatch(
			appSlice.actions.addModal({
				isHeaderWithColorBgAndIcon: true,
				title: 'Freeze card',
				subtitle: 'Learn about freeze card',
				headerBackgroundColor: '#0455A3',
				headerIcon: 'SNOWFLAKE_SLASH_BOLD',
				tag: 'FreezeCard',
				headClass: 'FreezeCard',
				isOpen: true,
				height: '70%',
				outsideParams: { mode },
			})
		);

		setFreeze(prev => !prev);
	};

	const onViewAll = () => {
		navigate(routes.cardSpendingLimits);
	};

	const onWithdraw = () => {};

	const onTopUp = () => {};

	const onCardDetails = () =>
		navigate(
			{ pathname: routes.cardDetails },
			{
				state: {
					cardInfo,
				},
			}
		);

	const openPersonalInfo = async () => {
		const resolveFunct = response => {
			navigate({ pathname: routes.personalInfo }, { state: { ...response } });
		};

		const rejectFunct = () => {
			HelperService.showNotification({
				type: 'error',
				title: t('Error'),
			});
		};

		const getInfo = () => {
			//request
		};

		try {
			HelperService.confirmPin({
				requestMethod: getInfo,
				resolveFunt: resolveFunct,
				rejectFunt: rejectFunct,
			});
		} catch (e) {
			console.log(e);
		}
	};

	const openDesignCard = () => {
		navigate(routes.cardEdit);
	};

	return (
		<div className='card-actions'>
			<div className='card-actions__header'>
				<div className='card-actions__title'>{t('Spending limits')}</div>

				<div className='card-actions__view-all' onClick={onViewAll}>
					{t('View all')}
				</div>
			</div>

			<div className='card-actions__limit'>
				<div className='card-actions__limit-label'>{t('Daily limit')}</div>

				<div className='card-actions__limit-value'>
					{dailyLimit.toLocaleString()}
					{currency}
				</div>
			</div>

			<div className='card-actions__actions'>
				<Action disabled label={t('Withdraw')} onClick={onWithdraw} icon={Icons.ARROW_CHEVRON_BOLD} />

				<Action disabled label={t('Top up')} onClick={onTopUp} icon={Icons.PLUS_BOLD} />

				<Action label={t('Card details')} onClick={onCardDetails} icon={Icons.CREDIT_CARD_AND_123} />

				<Action label={t('More')} onClick={() => setMenuOpen(v => !v)} icon={Icons.SETTINGS_ELLIPSIS_BOLD} />
			</div>

			{menuOpen && (
				<div className='card-actions__menu' ref={menuRef}>
					<MenuItem label={t('Personal info')} icon={Icons.PERSON_CIRCLE} onClick={openPersonalInfo} />
					<MenuItem label={t('Design card')} icon={Icons.PAINT_BRUSH} onClick={openDesignCard} />
					<MenuItem
						label={freeze ? t('Unfreeze card') : t('Freeze card')}
						onClick={handleToggleCard}
						icon={freeze ? Icons.SNOWFLAKE : Icons.SNOWFLAKE_SLASH}
					/>

					<div className='card-actions__menu-divider' />

					<MenuItem label={t('Close card')} danger icon={Icons.XMARK_CIRCLE} />
				</div>
			)}
		</div>
	);
};

export default CardActions;

const Action = ({ label, onClick, icon, disabled }) => {
	return (
		<div className={`card-actions__action ${disabled ? 'card-actions__action--disabled' : ''}`} onClick={onClick}>
			<div className='card-actions__action-icon'>
				<Icon type={icon} width={24} height={24} />
			</div>

			<div className='card-actions__action-label'>{label}</div>
		</div>
	);
};

const MenuItem = ({ label, danger, icon, onClick, disabled }) => {
	return (
		<div onClick={onClick} className={`card-actions__menu-item ${danger ? 'card-actions__menu-item--danger' : ''}`}>
			<Icon type={icon} width={20} height={20} />
			<span>{label}</span>
		</div>
	);
};
